export default "__VITE_ASSET__CxB$HCpf__"